import { connect } from 'react-redux';
import ServiceTemporarilyUnavailable from '../../components/ServiceTemporarilyUnavailable';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ServiceTemporarilyUnavailable);
